
const ChargSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RCustomer",
                "tableName": "",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CustomerName",
                "tableName": "",
                "label": "Customer Name",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "ChargeCode",
                "tableName": "",
                "label": "Charge Code",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "Description_1",
                "tableName": "",
                "label": "Description1",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    }
];
export default ChargSearchFormLayout;